import classNames from 'classnames/bind';
import URLIcon from 'ui/common/assets/recruiter/icon_url.svg';
import useToast from '../../../context/toast/useToast';
import { copyToClipboard } from '../../../util/copy';
import style from './JDProcess.module.scss';
const cx = classNames.bind(style);

interface IProps {
  readonly: boolean;
}

const JDProcessIconButtons = ({ readonly }: IProps) => {
  const { setToast } = useToast();

  const handleCopyLink = async () => {
    try {
      if (readonly) return;
      await copyToClipboard(window.location.href);
      setToast({ icon: 'POSITIVE', text: 'URL을 복사했습니다.', width: 312 });
    } catch (e) {
      setToast({ icon: 'FAILED', text: 'URL 복사에 실패했습니다.', width: 312 });
    }
  };

  return (
    <div className={cx('iconWrap')}>
      <button className={cx('icon')} onClick={handleCopyLink}>
        <URLIcon />
      </button>
    </div>
  );
};

export default JDProcessIconButtons;
